import React from "react";
import ReactDom from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import './index.css';

import {createBrowserRouter, RouterProvider,} from "react-router-dom";
import ProductDetails from "./components/product-details";
import Overview from "./components/Overview";

const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <Overview/>
        ),
    },
    {
        path: "details",
        element: (
            <ProductDetails/>
        ),
    },
]);

const element = <RouterProvider router={router}/>;

ReactDom.render(element, document.getElementById("root"));
